<template>
  <v-dialog v-model="dialogModel" persistent max-width="730" content-class="elevation-0">
    <v-card width="730" height="330" color="white" class="sigfloCard borderImage elevation-0">
      <v-card-text>
        <v-img class="sigfloLogo" src="@/assets/images/sigfloSymbolLogo.svg" height="142" width="142" />
        <div class="title sigfloH4 textEmphasis">Confirm</div>
        <div class="message sigfloBody400 textDefault">Delete {{ entityType }} ({{ entityName }})?</div>
        <div class="buttons">
          <v-btn
            rounded
            elevation="0"
            color="#7C40DC"
            class="mr-4 capitalize--text sigfloButtonSmall600"
            dark
            @click="callback"
          >
            <v-icon class="mr-2"> mdi-thumb-up-outline </v-icon>
            Yep!
          </v-btn>
          <v-btn
            rounded
            elevation="0"
            color="#F4F2F7"
            @click="$emit('close-dialog')"
            class="mr-2 capitalize--text sigfloButtonSmall600"
          >
            Go Back
            <v-icon class="ml-2"> mdi-cancel </v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      entityType: {
        Type: String,
        required: true
      },
      entityName: {
        type: String,
        required: true
      },
      callback: {
        type: Function,
        required: true
      },
      dialogModel: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {};
    }
  };
</script>

<style scoped>
  .borderImage {
    border: 0px solid transparent !important;
    background-image: url('~@/assets/images/dialogRightBorder.svg');
    background-position: right top; /* Align the image to the top right */
    background-repeat: no-repeat; /* Prevent the image from repeating */
  }
  .dialogRightBorder {
    position: absolute;
    right: 0;
    top: 0;
  }
  .title {
    position: absolute;
    left: 215px;
    top: 90px;
  }
  .message {
    position: absolute;
    left: 215px;
    top: 147px;
  }
  .buttons {
    position: absolute;
    left: 215px;
    top: 226px;
  }
  .sigfloLogo {
    position: absolute;
    left: 48px;
    top: 76px;
  }
</style>
